export default "<p>labelbarcode works!</p>\r\n"